import { render, staticRenderFns } from "./ChiPhiForm.vue?vue&type=template&id=6a839f25&"
import script from "./ChiPhiForm.vue?vue&type=script&lang=js&"
export * from "./ChiPhiForm.vue?vue&type=script&lang=js&"
import style0 from "./ChiPhiForm.vue?vue&type=style&index=0&id=6a839f25&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports